import WorkIm from '../assets/projects/workImg.jpeg'
import RealEst from '../assets/projects/realestate.jpg'
import crypto from '../assets/projects/crypto.png'
import travel from '../assets/projects/Travel.png'
import ecom from '../assets/projects/Ecom.png'
import Goal from '../assets/projects/GoalPlanner.png'

export const data=[
    {
        id:1,
        name:"Cryptocurrency Application",
        image:crypto,
        github:"https://github.com/HermanBide/crypto_app",
        live:"https://cryptocurrency-jade-theta.vercel.app/",
    },
    {
        id:2,
        name:"Travel-Booking Application",
        image:travel,
        github:"https://github.com/HermanBide/travel",
        live:"Under construction",
    },
    {
        id:3,
        name:"Ecommerce Application",
        image:ecom,
        github:"https://github.com/HermanBide/Ecom-app",
        live:"https://ecom-mfkuqm5b7-hermanbide.vercel.app/",
    },
    {
        id:4,
        name:"Goal Planner Application",
        image:Goal,
        github:"https://github.com/HermanBide/goal-planner",
        live:"Under construction",
    },


]